// Direction option values (stored in DB)
export const DIRECTION_OPTIONS = {
  OUTBOUND: "outbound",
  INBOUND: "inbound",
} as const;

export type DirectionType =
  (typeof DIRECTION_OPTIONS)[keyof typeof DIRECTION_OPTIONS];

// Direction option configuration
export const DIRECTION_OPTIONS_CONFIG = [
  {
    value: DIRECTION_OPTIONS.OUTBOUND,
    translationKey: "agents.agentDetail.outbound",
  },
  {
    value: DIRECTION_OPTIONS.INBOUND,
    translationKey: "agents.agentDetail.inbound",
  },
] as const;

// Function to get translated direction display value
export const getDirectionDisplayValue = (
  direction: DirectionType,
  t: any
): string => {
  const option = DIRECTION_OPTIONS_CONFIG.find(
    (opt) => opt.value === direction
  );
  return option ? t(option.translationKey) : direction;
};

// Function to get all direction options for Select component
export const getDirectionSelectOptions = (t: any) => {
  return DIRECTION_OPTIONS_CONFIG.map((option) => ({
    value: option.value,
    label: t(option.translationKey),
  }));
};
